import { faMapMarker } from '@fortawesome/pro-regular-svg-icons/faMapMarker'
import { Box, Flex, TextInput, Title } from '@mantine/core'
import { useEffect } from 'react'

import { useQueryGetUserTaxProfile } from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { type CoreUserAddress } from '@flecto/types'
import { AutocompleteAddress, SelectCountry } from '@flecto/ui'
import { Icon } from '@flecto/ui'

import { useFormContext } from './AddressForm'

export function AddressFormFields() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_locations' })
  const { data } = useQueryGetUserTaxProfile()
  const form = useFormContext()

  const selectAddress = (address: CoreUserAddress) => {
    if (address.address_label) {
      form.setFieldValue(
        'address_street',
        `${address.address_label}, ${address.address_street}`
      )
    } else {
      form.setFieldValue('address_street', address.address_street)
    }

    form.setFieldValue('latitude', address.latitude)
    form.setFieldValue('longitude', address.longitude)
    form.setFieldValue('address_city', address.address_city)
    form.setFieldValue('address_postal_code', address.address_postal_code)
    form.setFieldValue('address_country_name', address.address_country_name)
    form.setFieldValue('address_country_code', address.address_country_code)
    form.setFieldValue('address_region', address.address_region)
  }

  useEffect(() => {
    if (data?.legal_address?.legal && data.legal_address.address_country_code) {
      form.setFieldValue(
        'address_country_code',
        data.legal_address.address_country_code
      )
    }
  }, [data])

  return (
    <Box>
      <Title order={4} mb='sm'>
        {t('form.title')}
      </Title>
      <TextInput
        withAsterisk
        mb='md'
        aria-label='address-title'
        label={t('form.field_label.label')}
        placeholder={t('form.field_label.placeholder')}
        {...form.getInputProps('label')}
      />
      <AutocompleteAddress
        withAsterisk
        mb='md'
        style={{ flex: 1 }}
        leftSection={<Icon icon={faMapMarker} />}
        label={t('form.field_address.label')}
        placeholder={t('form.field_address.placeholder')}
        onSelectAddress={(address) => selectAddress(address)}
        countryToSearch={
          data?.legal_address?.legal
            ? data?.legal_address?.address_country_code
            : form.values.main
              ? form.values.address_country_code
              : undefined
        }
        {...form.getInputProps('address_street')}
      />
      <Flex gap='md' mb='md'>
        <TextInput
          withAsterisk
          style={{ flex: 1 }}
          label={t('form.field_city.label')}
          placeholder={t('form.field_city.placeholder')}
          {...form.getInputProps('address_city')}
        />
        <TextInput
          withAsterisk
          label={t('form.field_postal_code.label')}
          style={{ flex: 1 }}
          placeholder={t('form.field_postal_code.placeholder')}
          {...form.getInputProps('address_postal_code')}
        />
        <SelectCountry
          withAsterisk
          style={{ flex: 1 }}
          aria-label='address-country'
          label={t('form.field_country.label')}
          placeholder={t('form.field_country.placeholder')}
          disabled={Boolean(form.values.main) || data?.legal_address?.legal}
          {...form.getInputProps('address_country_code')}
        />
      </Flex>
    </Box>
  )
}
